
import React from 'react';
import { 
  Home, 
  Music, 
  Users, 
  BarChart2, 
  DollarSign, 
  Library, 
  ShoppingBag, 
  Calendar, 
  FileText, 
  Video, 
  Copyright, 
  Share, 
  Radio, 
  Flame,
  GraduationCap,
  Film,
  Sparkles,
  ShoppingCart,
  LayoutDashboard,
  TrendingUp,
  User,
  Heart,
  Award,
  Headphones,
  Coins
} from 'lucide-react';
import { NavItem, NavigationItem } from './types';

export const navLinks: NavItem[] = [
  { path: '/', label: 'Home', icon: <Home className="h-4 w-4" /> },
  { path: '/releases', label: 'Releases', icon: <Music className="h-4 w-4" /> },
  { path: '/musicians-network', label: 'Network', icon: <Users className="h-4 w-4" /> },
  { path: '/analytics', label: 'Analytics', icon: <BarChart2 className="h-4 w-4" /> },
  { path: '/royalties', label: 'Royalties', icon: <DollarSign className="h-4 w-4" /> },
  { path: '/funding', label: 'Funding', icon: <Coins className="h-4 w-4" /> },
  { path: '/marketing', label: 'Marketing', icon: <Flame className="h-4 w-4" /> },
  { path: '/sync', label: 'Sync', icon: <Film className="h-4 w-4" /> },
  { path: '/artist-progress', label: 'Progress', icon: <Sparkles className="h-4 w-4" /> },
  { path: '/merchandise', label: 'Merchandise', icon: <ShoppingCart className="h-4 w-4" /> },
  { path: '/library', label: 'Library', icon: <Library className="h-4 w-4" /> },
  { path: '/marketplace', label: 'Marketplace', icon: <ShoppingBag className="h-4 w-4" /> },
  { path: '/gig-management', label: 'Gigs', icon: <Calendar className="h-4 w-4" /> },
  { path: '/legal-tools', label: 'Legal', icon: <FileText className="h-4 w-4" /> },
  { path: '/live-streaming', label: 'Streaming', icon: <Video className="h-4 w-4" /> },
  { path: '/music-rights-admin', label: 'Rights Admin', icon: <Copyright className="h-4 w-4" /> },
  { path: '/collaboration', label: 'Collaboration', icon: <Share className="h-4 w-4" /> },
  { path: '/learning', label: 'Academy', icon: <GraduationCap className="h-4 w-4" /> },
  { path: '/radio', label: 'Radio', icon: <Radio className="h-4 w-4" /> },
];

export const navigationItems: NavigationItem[] = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: <LayoutDashboard className="h-4 w-4" />,
    color: "text-blue-500",
  },
  {
    title: "Analytics",
    href: "/analytics",
    icon: <BarChart2 className="h-4 w-4" />,
    color: "text-purple-500",
  },
  {
    title: "Releases",
    href: "/releases",
    icon: <Music className="h-4 w-4" />,
    color: "text-orange-500",
  },
  {
    title: "Funding",
    href: "/funding",
    icon: <Coins className="h-4 w-4" />,
    color: "text-green-500",
  },
  {
    title: "Marketing",
    href: "/marketing",
    icon: <TrendingUp className="h-4 w-4" />,
    color: "text-green-500",
  },
  {
    title: "Network",
    href: "/network",
    icon: <Users className="h-4 w-4" />,
    color: "text-red-500",
    submenu: [
      {
        title: "Musicians Network",
        href: "/musicians-network",
        icon: <User className="h-4 w-4" />,
      },
      {
        title: "Musicians Match",
        href: "/musicians-match",
        icon: <Heart className="h-4 w-4" />,
      },
      {
        title: "Award Networking",
        href: "/award-networking",
        icon: <Award className="h-4 w-4" />,
      },
    ],
  },
  {
    title: "Collaboration",
    href: "/collaboration",
    icon: <Headphones className="h-4 w-4" />,
    color: "text-cyan-500",
  },
];

export const mainNavLinks = navLinks.slice(0, 6); // Include funding in main links
export const extraNavLinks = navLinks.slice(6);
